import HttpService from '@/common/services/HttpService'
import { type RoleDTOV1 } from '@/common/types/roles'

export const fetchRoles = async () => {
  return HttpService.getData<RoleDTOV1[]>('/api/v1/roles')
}
